<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row>
          <b-col md="12" class="d-flex justify-content-end">
            <b-button variant="primary" v-if="IsAdmin()" v-b-modal.modal-add-designation>
              <feather-icon icon="PlusIcon" class="mr-50" />
              Add New Designation
            </b-button>
            <b-modal id="modal-add-designation" ok-only ok-title="Add" centered size="lg" title="Add Designation"
              :hide-footer="true" ref="addDesignation">
              <AddDesignation @DesignationAdded="closeAddModal" />
            </b-modal>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
            </b-form-group>
          </b-col>

          <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
            <b-button variant="outline-danger" size="sm" @click="clearFilters">
              Clear Filters
            </b-button>
          </b-col>

          <b-col cols="12">
            <b-table striped hover responsive :per-page="perPage" :current-page="currentPage"
              :items="filteredDesignations" :fields="designation_fields" :filter-included-fields="filterOn">

              <!-- Column Header with Filter Inputs -->
              <template #head(departmentName)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('departmentName')" style="cursor: pointer">Department Name</span>
                  <b-form-input v-model="filters.departmentName" placeholder="Filter by Department Name"
                    @input="applyFilters" size="sm" />
                </div>
              </template>

              <template #head(designationName)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('designationName')" style="cursor: pointer">Designation Name</span>
                  <b-form-input v-model="filters.designationName" placeholder="Filter by Designation Name"
                    @input="applyFilters" size="sm" />
                </div>
              </template>

              <template #head(workingHours)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('workingHours')" style="cursor: pointer">Working Hours</span>
                  <b-form-input v-model="filters.workingHours" placeholder="Filter by Working Hours"
                    @input="applyFilters" size="sm" />
                </div>
              </template>

              <template #head(minimumSalary)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('minimumSalary')" style="cursor: pointer">Minimum Salary</span>
                  <b-form-input v-model="filters.minimumSalary" placeholder="Filter by Minimum Salary"
                    @input="applyFilters" size="sm" />
                </div>
              </template>

              
              <template #head(maximumSalary)="scope">
                <div class="d-flex flex-column">
                  <span @click="toggleSort('maximumSalary')" style="cursor: pointer">Maximum Salary</span>
                  <b-form-input v-model="filters.maximumSalary" placeholder="Filter by Maximum Salary"
                    @input="applyFilters" size="sm" />
                </div>
              </template>


              <template v-slot:cell(actions)="data">
                <b-dropdown variant="link" toggle-class="p-0" no-caret class="m-1">
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                  </template>
                  <b-dropdown-item @click="editDesignation(data.item)" :disabled="!IsAdmin()" v-b-modal.modal-edit-designation>
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item :disabled="!IsAdmin()" @click="removeDesignation(data.item.id)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner variant="success" label="Spinning" block v-if="loading"
                style="width: 3rem; height: 3rem"></b-spinner>
            </div>
            <b-modal id="modal-edit-designation" ok-only ok-title="Edit" centered size="lg" title="Edit Designation"
              :hide-footer="true" ref="editDesignation">
              <EditDesignation :designation="currentDesignation" @DesignationUpdated="closeEditModal" />
            </b-modal>
          </b-col>

          <b-col cols="12">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
              class="my-0" />
              <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import {
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BCardBody,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BDropdown,
  BDropdownItem,
  BModal,
} from 'bootstrap-vue';
import { IsAdmin } from "@/@core/utils/validations/permissionCheck";
import AddDesignation from './AddDesignation.vue';
import EditDesignation from './EditDesignation.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BCardBody,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BModal,
    AddDesignation,
    EditDesignation,
  },
  data() {
    return {
      currentDesignation: {},
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filters: {
        departmentName: '',
        designationName: '',
        workingHours: '',
        minimumSalary: '',
        maximumSalary: ''
      },
      filterOn: ['departmentName', 'designationName', 'workingHours', 'minimumSalary', 'maximumSalary'],
      designation_fields: [
        { key: 'departmentName', label: 'Department Name', sortable: true },
        { key: 'designationName', label: 'Designation Name', sortable: true },
        { key: 'workingHours', label: 'Working Hours', sortable: true },
         { key: 'minimumSalary', label: 'Minimum Salary', sortable: true },
         { key: 'maximumSalary', label: 'Maximum Salary', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
    };
  },
  computed: {
    ...mapGetters('designationModule', {
      designations: 'designations',
      loading: 'loading',
    }),
    filteredDesignations() {
      const filtered = this.designations.filter(designation => {
    return (
      (!this.filters.departmentName || designation.departmentName.toLowerCase().includes(this.filters.departmentName.toLowerCase())) &&
      (!this.filters.designationName || designation.designationName.toLowerCase().includes(this.filters.designationName.toLowerCase())) &&
      (!this.filters.workingHours || designation.workingHours.toString().includes(this.filters.workingHours)) &&
      (!this.filters.minimumSalary || designation.minimumSalary.toString().includes(this.filters.minimumSalary)) &&
      (!this.filters.maximumSalary || designation.maximumSalary.toString().includes(this.filters.maximumSalary))
    );
  });

  return filtered.sort((a, b) => {
    const deptA = a.departmentName?.toLowerCase() || '';
    const deptB = b.departmentName?.toLowerCase() || '';
    return deptA.localeCompare(deptB);
  });
    }
  },
  methods: {
    ...mapActions('designationModule', ['getDesignationListAction', 'removeDesignationAction']),
    editDesignation(designation) {
      this.currentDesignation = designation;
    },
    addDesignation(designation) {
      this.currentDesignation = designation;
    },
   

    removeDesignation(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeDesignationAction(id)
            .then(() => {
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: 'Designation has been deleted',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              });
              this.getDesignationListAction().then(() => {
                this.totalRows = this.designations.length;
              });
            })
            .catch((error) => {
              this.$swal({
                icon: 'error',
                title: 'Error!',
                text: error.response.data.message,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              });
              this.getDesignationListAction().then(() => {
                this.totalRows = this.designations.length;
              });
            });
        } else if (result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            text: 'Designation not deleted',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          });
        }
      });
    },
    async closeAddModal() {
      this.$refs.addDesignation.hide();
      await this.getDesignationListAction().then(() => {
        this.totalRows = this.designations.length;
      });
      this.totalRows = this.designations.length;
    },
    async closeEditModal() {
      this.$refs.editDesignation.hide();
      await this.getDesignationListAction().then(() => {
        this.totalRows = this.designations.length;
      });
      this.totalRows = this.designations.length;
    },
    applyFilters() {
      this.currentPage = 1; // Reset to the first page when filters are applied
    },
    clearFilters() {
      // Reset all filter values to their default state
      this.filters = {
        departmentName: '',
        designationName: '',
        workingHours: ''
      };

      // Reset the current page and filtered items
      this.currentPage = 1;
    }
  },
  async mounted() {
    await this.getDesignationListAction().then(() => {
      this.totalRows = this.designations.length;
    });
  },
  setup(){
    return {
      IsAdmin
    }
  }
};
</script>
